<template>
    <section>

     <div id="editor-container" ref="editor"></div>

         <input type="file" ref="image" class="d-none" @change="fnOnChangeButtonImage" hidden/>
         <input type="hidden" v-model="content" name="content">
         <input type="hidden" v-model="imgjson" name="imgjson">

    </section>
</template>

<script>
import Axios from 'axios'
import  Quill from 'quill';
import  QuillImageDropAndPaste, { ImageData as QuillImageData } from 'quill-image-drop-and-paste'
import ImageResize from 'quill-image-resize-module-fix-for-mobile'
import htmlEditButton from "quill-html-edit-button"  // https://github.com/benwinding/quill-html-edit-button


import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

let fontSizeStyle = Quill.import('attributors/style/size');


const BlockEmbed = Quill.import('blots/block/embed');

const toolbarOptions = [
    [{ 'font': [] }],
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'script': 'super' }, { 'script': 'sub' }],
    [{ 'header': '1' }, { 'header': '2' }, 'blockquote', 'code-block'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
    [{ 'direction': 'rtl' }, { 'align': [] }],
    ['link', 'image', 'video'], // , 'formula'
    ['clean']
]




export default{
    data: function () {

      return {
            name: 'quill-editor',
            quill:null,
            isVideo:false,
            isImageClick:false,
            content: '',
            images:[],
            listImageSave:[],
            updateParams: {},
            blobUrl:null,
            _content:'',
            cnt : 0
      }
    }
    , model:{
          prop:'content'
        , event: 'getEditorInfo'
    }
    , /* props: ['initValue', 'width'] */
      props: {
      content: String,
      value: String,
      disabled: {
        type: Boolean,
        default: false
      }
       }
   /*  , components: {
        Element,
        quillEditor,
        ImageResize,
    } */
    , watch:{
        initValue:function(newVal, oldVal){
            this.content = newVal;
        },
        // Watch content change
        content(newVal, oldVal) {
        if (this.quill) {
          if (newVal && newVal !== this._content) {
            this._content = newVal
            this.quill.pasteHTML(newVal)
          } else if(!newVal) {
            this.quill.setText('')
          }
        }
        }
        // ,
        //  value(newVal, oldVal) {
        // if (this.quill) {
        //   if (newVal && newVal !== this._content) {
        //     this._content = newVal
        //     this.quill.pasteHTML(newVal)
        //   } else if(!newVal) {
        //     this.quill.setText('')
        //   }
        // }
        //  }
    }
    , create: function(){
        this.content = this.initValue;
    }
    , mounted: function () {
        Quill.register(fontSizeStyle, true);
        Quill.register('modules/imageResize', ImageResize);
        Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);
        Quill.register('modules/htmlEditButton', htmlEditButton);
        this.fnOnInit();

    }
    , methods: {
        clickImage:function(e){
           this.isImageClick = true;
        },
        fnOnInit:function(){
          let vm = this;
            this.quill = new Quill('#editor-container',{
            compatibilityMode: false,
            theme: 'snow',
                modules: {
                    toolbar: {
                      container: toolbarOptions
                      , handlers : {
                         image : function (value) {
                            if (value) {
                                vm.isImageClick = true;
                                vm.$refs.image.click();
                            } else {
                                vm.quill.format('image', false);
                            }
                         }
                      }

                    },
                     imageDropAndPaste: {
                        // add an custom image handler
                        handler: this.fnOnChageDragimageHandler

                    },
                    imageResize: {
                        /* displayStyles: {
                          backgroundColor: 'black',
                          border: 'none',
                          color: 'white'
                        },
                        displaySize: true ,
                        modules: [ 'Resize', 'DisplaySize', 'Toolbar' ] */
                        parchment: Quill.import('parchment')
                    },
                    htmlEditButton: {
                      // debug: true, // logging, default:false
                      msg: "HTML 코드로 수정합니다", //Custom message to display in the editor, default: Edit HTML here, when you click "OK" the quill editor's contents will be replaced
                      okText: "완료", // Text to display in the OK button, default: Ok,
                      cancelText: "취소", // Text to display in the cancel button, default: Cancel
                      buttonHTML: "&lt;&gt;", // Text to display in the toolbar button, default: <>
                      buttonTitle: "HTML 소스로 편집", // Text to display as the tooltip for the toolbar button, default: Show HTML source
                      syntax: false, // Show the HTML with syntax highlighting. Requires highlightjs on window.hljs (similar to Quill itself), default: false
                      // prependSelector: 'div#myelement', // a string used to select where you want to insert the overlayContainer, default: null (appends to body),
                      editorModules: {} // The default mod
                    },
                }
            });

             if (this.value || this.content) {
                    this.quill.pasteHTML(this.value || this.content);
             }

          this.quill.on('selection-change', range => {

            if (!range) {
              this.$emit('blur', this.quill)
            } else {
              this.$emit('focus', this.quill)
            }
          });

          // Update model if text changes
          this.quill.on('text-change', (delta, oldDelta, source) => {

            let html = this.$refs.editor.children[0].innerHTML;

            const quill = this.quill
            const text = this.quill.getText();

            if (html === '<p><br></p>') html = ''
              this._content = html
              this.$emit('input', this._content)
              this.$emit('change', { html, text, quill });
              this.$emit('getEditorInfo', html);
            });
        }
        , onEditorChange:function(event) {

            this.$emit('getEditorInfo', event);
        }
        , fnOnChangeButtonImage:function(event){

            let vm = this;
            let fr = new FileReader();
            let file = event.target.files[0];
            let idx = vm.quill.getSelection() ? vm.quill.getSelection().index : 0;
            let _form = new FormData();
            let _datas = vm.setFileRemindFromFile(file);
            let _inner = $("#fileKey").val();

                _form.append('uploadFiles', file);
                _form.append('paramText', _inner);
                _form.append('resultData', idx);
                _form.append('defaultView', _inner);
                _form.append('reason', 'editor');
                _form.append('paramOption', JSON.stringify(_datas) );


              Axios.post("/api/img/upload", _form, { headers: { 'Content-Type': 'multipart/form-data' }

              }).then(function(response) {
                    let _data = response.data.result;
                    let _onePath = _data.substring(0,8);
                    let _filnalPath =  "/img/" + _onePath + "/" + _data;
                    vm.quill.insertEmbed(idx, 'image', _filnalPath);
                    vm.quill.setSelection(idx + 1);

                }).catch(function(ex) {
                    console.log(ex);
                });
        }
        , setFileRemindFromFile(_data){
          return  {
              name : _data.name,
              sizeText :_data.sizeText,
              size : _data.size,
              type : _data.type,
              ext : null,
              width : 640,
              height : 480,
              color : null
           };
        }
        , fnOnChageDragimageHandler:function(dataURL, type, imageData){
                let vm = this;
                const blob = imageData.toBlob();
                const file = imageData.toFile();


                let _img = file,  idx = vm.quill.getSelection() ? vm.quill.getSelection().index : 0;

                let _form = new FormData();
                let _datas = vm.setFileRemindFromFile(file);
                let _inner = $("#fileKey").val();
                _form.append('uploadFiles', file);
                _form.append('paramText', _inner);
                _form.append('resultData', idx);
                _form.append('defaultView', _inner);
                _form.append('reason', 'editor');
                _form.append('paramOption', JSON.stringify(_datas) );

                 Axios.post("/api/img/upload", _form, { headers: { 'Content-Type': 'multipart/form-data' }

                }).then(function(response) {
                    let _data = response.data.result;
                    let _onePath = _data.substring(0,8);
                    let _filnalPath =  "/img/" + _onePath + "/" + _data;
                    vm.quill.insertEmbed(idx, 'image', _filnalPath);
                    vm.quill.setSelection(idx + 1);

                }).catch(function(ex) {
                    console.log(ex);
                });
        }

    }
  }
</script>

<style>

/* 비디오 클릭시 삐져 나가는 문제 수정 :  https://github.com/quilljs/quill/issues/360 */
.ql-tooltip {
  left: 0 !important;
  top: 0 !important;
}

</style>
